<template>
	<MStateBox :loading="report_list.loading" :empty="isEmpty" class="ir-module-block">
		<CCardReportPanel v-for="(item, index) in pageData" :key="index" :item="item"></CCardReportPanel>
		<slot name="footer"></slot>
	</MStateBox>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import CCardReportPanel from '@/view/enterprise_rebuild/materials/shared/report/CardReportPannel.vue';
import MStateBox from '@/view/enterprise_rebuild/components/MStateBox.vue';
import { useModuleData } from '@/view/enterprise_rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';

const { report_list } = useModuleData();
const { config, loadModuleConfig } = useModuleConfig();

const initialized = ref(false);
const pageData = ref([]);

// 空状态判断
const isEmpty = computed(() => {
	return report_list.empty || !pageData.value?.length;
});

const tabOption = computed(() => {
	return (config.value?.tab || []).sort((a, b) => a.sort - b.sort).filter(v => v.isPublish);
});

async function refresh(done) {
	await loadModuleConfig('report');
	if (tabOption.value.length) {
		let allTab = tabOption.value.find(v => v.id === 'report_all' && v.isPublish);
		let rating;
		if (allTab) {
			rating = '';
		} else {
			rating = tabOption.value.map(v => v.value);
		}
		// 使用与历史组件相同的参数名称
		await report_list.refresh({
			pagestart: 0,
			pagenum: 20,
			rating
		});

		// 数据访问路径：根据历史组件，response?.rows
		let data = report_list.data?.rows || [];
		data = (data || []).slice(0, 3);
		pageData.value = data;
	} else {
		report_list.loading = false;
	}

	if (!initialized.value) initialized.value = true;

	done && done();
}

onMounted(() => {
	refresh();
});
</script>

<style lang="less" scoped></style>
